import React from 'react';
import '../styles/HelpSupport.css';

const HelpSupport = () => {

  const helpCategories = [
    { icon: "fa-solid fa-rocket", title: "Getting Started", articles: "11 Articles", desc: "Learn the basics", color: "blue" },
    { icon: "fa-regular fa-file-lines", title: "Billing & Invoices", articles: "18 Articles", desc: "Create & manage invoices", color: "green" },
    { icon: "fa-regular fa-credit-card", title: "Payments", articles: "12 Articles", desc: "Receive & track payments", color: "purple" },
    { icon: "fa-solid fa-file-invoice-dollar", title: "GST & Tax", articles: "15 Articles", desc: "GST filing & tax settings", color: "orange" },
    { icon: "fa-solid fa-chart-line", title: "Reports", articles: "14 Articles", desc: "Understand reports", color: "teal" },
    { icon: "fa-regular fa-user", title: "Account & Users", articles: "10 Articles", desc: "Manage account & users", color: "red" }
  ];

  const popularArticles = [
    { title: "How to create an invoice?", desc: "Learn how to create and send professional invoices to your customers." },
    { title: "How to record a payment?", desc: "Record payments made by your customers against invoices." },
    { title: "How to file GST returns?", desc: "Step-by-step guide to file GSTR-1, GSTR-3B and other returns." },
    { title: "How to add a new user?", desc: "Invite team members and set roles & permissions." },
    { title: "How to backup data?", desc: "Learn how to backup and restore your business data." }
  ];

  const videoGuides = [
    { title: "Getting Started with MyOwnBill", desc: "A quick overview to get you started.", time: "04:35" },
    { title: "Create & Send Invoices", desc: "Learn to create and send invoices easily.", time: "06:12" },
    { title: "Record Payments", desc: "How to record and manage payments.", time: "03:45" },
    { title: "GST Filing in MyOwnBill", desc: "File your GST returns in a few simple steps.", time: "08:20" }
  ];

  const supportTickets = [
    { id: "#TK-1024", title: "Unable to generate GST report", status: "Open", date: "20 May 2025", statusColor: "green" },
    { id: "#TK-1023", title: "Payment not reflecting in invoice", status: "In Progress", date: "19 May 2025", statusColor: "orange" },
    { id: "#TK-1022", title: "Need help with user roles", status: "Resolved", date: "16 May 2025", statusColor: "teal" },
    { id: "#TK-1021", title: "Error while filing GSTR-1", status: "Resolved", date: "14 May 2025", statusColor: "teal" }
  ];

  return (
    <div className="sup-wrapper">
      <div className="sup-layout-grid">
        
        {/* LEFT COLUMN: Main Content */}
        <div className="sup-left-col">
          
          {/* Hero Section */}
          <div className="sup-hero-card">
            <div className="sup-hero-content">
              <h1 className="sup-hero-title">Hi Admin! How can we help you today? 👋</h1>
              <p className="sup-hero-subtitle">Search our help articles, guides or contact our support team.</p>
              
              <div className="sup-search-container">
                <input type="text" placeholder="Search for articles, topics or keywords..." className="sup-search-input" />
                <button className="sup-search-btn"><i className="fa-solid fa-magnifying-glass"></i> Search</button>
              </div>

              <div className="sup-popular-topics">
                <span className="sup-topics-label">Popular Topics:</span>
                <span className="sup-topic-pill">Invoices</span>
                <span className="sup-topic-pill">Payments</span>
                <span className="sup-topic-pill">GST Filing</span>
                <span className="sup-topic-pill">Reports</span>
                <span className="sup-topic-pill">User Management</span>
              </div>
            </div>
            <div className="sup-hero-graphic">
              {/* Fallback graphical representation for the headphones */}
              <div className="sup-graphic-circle">
                <i className="fa-solid fa-headset"></i>
                <div className="sup-graphic-badge"><i className="fa-solid fa-question"></i></div>
              </div>
            </div>
          </div>

          {/* Help Categories */}
          <div className="sup-section">
            <h3 className="sup-section-title">Help Categories</h3>
            <div className="sup-categories-grid">
              {helpCategories.map((cat, i) => (
                <div className="sup-category-card" key={i}>
                  <div className={`sup-cat-icon sup-text-${cat.color} sup-bg-${cat.color}-light`}><i className={cat.icon}></i></div>
                  <strong className="sup-cat-title">{cat.title}</strong>
                  <span className="sup-cat-articles">{cat.articles}</span>
                  <p className="sup-cat-desc">{cat.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Split Section: Articles & Videos */}
          <div className="sup-split-grid">
            
            {/* Popular Articles */}
            <div className="sup-card sup-p-24 sup-flex-col">
              <h3 className="sup-card-title sup-mb-16">Popular Articles</h3>
              <div className="sup-article-list">
                {popularArticles.map((art, i) => (
                  <div className="sup-article-item" key={i}>
                    <div className="sup-art-icon"><i className="fa-regular fa-file-lines"></i></div>
                    <div className="sup-art-text">
                      <strong>{art.title}</strong>
                      <span>{art.desc}</span>
                    </div>
                    <a href="#" className="sup-link">View Article</a>
                  </div>
                ))}
              </div>
              <div className="sup-mt-auto">
                <a href="#" className="sup-link">View all articles <i className="fa-solid fa-arrow-right"></i></a>
              </div>
            </div>

            {/* Video Guides */}
            <div className="sup-card sup-p-24 sup-flex-col">
              <div className="sup-flex-between sup-mb-16">
                <h3 className="sup-card-title">Video Guides</h3>
                <a href="#" className="sup-link">View all</a>
              </div>
              <div className="sup-video-list">
                {videoGuides.map((vid, i) => (
                  <div className="sup-video-item" key={i}>
                    <div className="sup-video-thumb">
                      <i className="fa-solid fa-play"></i>
                      <span className="sup-vid-time">{vid.time}</span>
                    </div>
                    <div className="sup-vid-text">
                      <strong>{vid.title}</strong>
                      <span>{vid.desc}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

          </div>

          {/* Footer Grid */}
          <div className="sup-footer-grid">
            <div className="sup-card sup-p-20 sup-flex-row-center">
              <div className="sup-footer-icon sup-bg-blue-light sup-text-blue"><i className="fa-regular fa-comment-dots"></i></div>
              <div className="sup-footer-text">
                <strong>Still need help?</strong>
                <span>Can't find what you're looking for?</span>
                <a href="#" className="sup-link sup-mt-4">Contact Support Team <i className="fa-solid fa-arrow-right"></i></a>
              </div>
            </div>
            <div className="sup-card sup-p-20 sup-flex-row-center">
              <div className="sup-footer-icon sup-bg-blue-light sup-text-blue"><i className="fa-solid fa-shield-halved"></i></div>
              <div className="sup-footer-text">
                <strong>We value your feedback</strong>
                <span>Help us improve by sharing your experience.</span>
                <a href="#" className="sup-link sup-mt-4">Give Feedback <i className="fa-solid fa-arrow-right"></i></a>
              </div>
            </div>
          </div>

        </div>

        {/* RIGHT COLUMN: Sidebars */}
        <div className="sup-right-col">
          
          {/* Contact Support */}
          <div className="sup-card sup-p-24">
            <h3 className="sup-card-title">Contact Support</h3>
            <p className="sup-card-sub sup-mb-20">Our support team is here to help you.</p>
            
            <div className="sup-contact-list">
              <div className="sup-contact-item">
                <div className="sup-contact-icon"><i className="fa-regular fa-comment-dots"></i></div>
                <div className="sup-contact-info">
                  <div className="sup-flex-center"><strong>Live Chat</strong> <span className="sup-status-online"><span className="sup-dot"></span> Online</span></div>
                  <span>Chat with our support team</span>
                </div>
              </div>
              
              <div className="sup-contact-item">
                <div className="sup-contact-icon"><i className="fa-regular fa-envelope"></i></div>
                <div className="sup-contact-info">
                  <strong>Email Support</strong>
                  <span className="sup-text-dark">support@myownbill.com</span>
                  <span>We typically reply within 2 hours</span>
                </div>
              </div>

              <div className="sup-contact-item">
                <div className="sup-contact-icon"><i className="fa-solid fa-phone"></i></div>
                <div className="sup-contact-info">
                  <strong>Phone Support</strong>
                  <span className="sup-text-dark">+91 98765 43210</span>
                  <span>Mon - Sat, 9:00 AM to 6:00 PM</span>
                </div>
              </div>
            </div>

            <button className="sup-btn-primary sup-w-full sup-mt-20">Create Support Ticket</button>
          </div>

          {/* Your Support Tickets */}
          <div className="sup-card sup-p-24">
            <div className="sup-flex-between sup-mb-20">
              <h3 className="sup-card-title">Your Support Tickets</h3>
              <a href="#" className="sup-link">View All</a>
            </div>
            
            <div className="sup-ticket-list">
              {supportTickets.map((tk, i) => (
                <div className="sup-ticket-item" key={i}>
                  <div className="sup-tk-top">
                    <strong className="sup-tk-id">{tk.id}</strong>
                    <span className={`sup-badge sup-badge-${tk.statusColor}`}>{tk.status}</span>
                    <span className="sup-tk-date">{tk.date}</span>
                  </div>
                  <div className="sup-tk-title">{tk.title}</div>
                </div>
              ))}
            </div>
          </div>

          {/* System Status */}
          <div className="sup-card sup-p-24">
            <div className="sup-sys-header">
              <div className="sup-sys-icon"><i className="fa-solid fa-shield-check"></i></div>
              <div className="sup-sys-title">
                <strong>System Status</strong>
                <span className="sup-dot-green"></span>
              </div>
            </div>
            <div className="sup-sys-body">
              <strong>All Systems Operational</strong>
              <p>Everything is running smoothly.</p>
              <span className="sup-sys-time">Last updated: 20 May 2025, 11:30 AM</span>
            </div>
            <div className="sup-divider"></div>
            <a href="#" className="sup-link-center">View Status Page</a>
          </div>

        </div>

      </div>
    </div>
  );
};

export default HelpSupport;